var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lc-list" },
    _vm._l(_vm.count, function (n) {
      return _c(
        "div",
        { key: n, staticClass: "lc-item" },
        [
          _c("v-skeleton-loader", {
            staticClass: "skeleton-row",
            attrs: {
              type: _vm.avatar
                ? "list-item-avatar-two-line"
                : "list-item-two-line",
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }